import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import { t } from 'i18next';

export const PatientReviewsErrorHandlingWidget = () => (
  <Layout.Stack alignItems="normal" space={8}>
    <Text color="$core.color.brand.100" fontSize="md" fontWeight="regular">
      {`${t('ERROR_PAGE.500.heading')} ${t('ERROR_PAGE.500.subHeading')}`}
    </Text>
    <Text>{t('ERROR_PAGE.500.body1')}</Text>
  </Layout.Stack>
);
